import request from '@/utils/request'

export function getCourseProfile(courseId) {
  return request({
    url: `/amc/course-profile/${courseId}`,
    method: 'get'
  })
}

export function saveCourseProfile(courseId, content) {
  return request({
    url: `/amc/course-profile/${courseId}`,
    method: 'post',
    data: content,
    headers: { 'Content-Type': 'application/json' }
  })
}
